import { render, staticRenderFns } from "./IconBase18.vue?vue&type=template&id=ede3d994&scoped=true"
import script from "./IconBase18.vue?vue&type=script&lang=js"
export * from "./IconBase18.vue?vue&type=script&lang=js"
import style0 from "./IconBase18.vue?vue&type=style&index=0&id=ede3d994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede3d994",
  null
  
)

export default component.exports